import { Switch, Route } from 'react-router-dom';
import { Layout } from 'antd';
import './App.less';
import StudentDetail from './pages/StudentDetail';
import Header from './components/Header';
const { Content } = Layout;

function App() {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header />
      <Content style={{ padding: '0 50px', backgroundColor: '#fff' }}>
        <Layout style={{ background: '#fff' }}>
          <Switch>
            <Route path="/:studentId/:kcId/:date">
              <StudentDetail />
            </Route>
            <Route path="/">
              <h1>404</h1>
              {window.origin}/:studentId/:kcId/:date 형식의 url을 입력해주세요.
            </Route>
          </Switch>
        </Layout>
      </Content>
    </Layout>
  );
}

export default App;
